import { JSX } from 'react'

import { IconProps } from '../../icon'

const Gym: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_1081_57)'>
      <path
        d='M2.35713 17.8613C-0.133303 22.1616 1.3342 27.6668 5.63451 30.1569C9.93501 32.6474 15.4399 31.1799 17.9304 26.8796L21.925 19.9815L6.35176 10.9631L2.35713 17.8613Z'
        fill='#EBDBBF'
      />
      <path
        d='M20.0327 5.29395L18.1865 8.4817C18.7836 8.82763 18.9873 9.59182 18.6416 10.1889L17.2341 12.6196C16.8885 13.2168 16.124 13.4204 15.5268 13.0747L14.1609 15.4336L21.9475 19.9429L23.31 17.5896C25.8003 13.2893 24.333 7.78413 20.0327 5.29395Z'
        fill='#F0EBE2'
      />
      <path
        d='M15.5269 13.0747C14.9297 12.7287 14.7259 11.9646 15.0718 11.3674L16.4793 8.9368C16.8249 8.33962 17.5894 8.13599 18.1866 8.48168L20.0325 5.29393C15.7322 2.80343 10.2271 4.27099 7.73687 8.57131L6.35187 10.9632L14.1606 15.4336L15.5269 13.0747Z'
        fill='#F0EBE2'
      />
      <path
        d='M15.5323 13.0779L15.5215 13.0716C14.9272 12.7276 14.7246 11.9668 15.0686 11.3728L16.4824 8.93163C16.8264 8.33738 17.5869 8.13451 18.1812 8.47876L18.1919 8.48488C18.7862 8.82913 18.9888 9.58963 18.6448 10.1838L17.231 12.625C16.887 13.219 16.1263 13.4219 15.5323 13.0779Z'
        fill='white'
      />
      <path
        d='M32.4912 16.7529C32.4385 16.4944 32.227 16.2929 31.9653 16.2549C31.7028 16.2166 31.4377 16.3545 31.3176 16.5908C31.2024 16.8174 31.2373 17.0977 31.4048 17.2891C31.5798 17.4893 31.8706 17.5566 32.116 17.4551C32.3885 17.3426 32.5503 17.0425 32.4912 16.7529Z'
        fill='black'
      />
      <path
        d='M30.9248 18.5188C30.6248 18.3452 30.241 18.4475 30.0674 18.7473L28.6211 21.2454C28.1692 22.0251 27.1672 22.2923 26.3875 21.8406C25.6077 21.389 25.3406 20.387 25.7922 19.6072L31.5906 9.59427C33.3569 6.54421 32.3125 2.62552 29.2622 0.859394C26.2119 -0.906981 22.2935 0.137519 20.5273 3.18777L19.7937 4.45439C17.6982 3.41358 15.3254 3.17189 13.0444 3.77983C10.56 4.44214 8.48216 6.03202 7.19385 8.25708L1.81422 17.5469C0.525661 19.7718 0.180911 22.3653 0.842911 24.8496C1.50504 27.3338 3.09516 29.4116 5.32004 30.7C6.80591 31.5603 8.45579 32 10.1279 32C10.96 32 11.7973 31.8911 12.6228 31.6711C15.1072 31.0091 17.1848 29.419 18.4732 27.1941L22.468 20.296C22.4717 20.2896 22.4746 20.2827 22.478 20.2764C22.4819 20.2698 22.4866 20.2637 22.4905 20.2571L23.853 17.9041C25.1416 15.6792 25.4863 13.0857 24.8242 10.6013C24.2163 8.32033 22.8255 6.38258 20.8797 5.08327L21.6133 3.81639C23.0327 1.36527 26.1819 0.525643 28.6333 1.94533C29.821 2.63283 30.6694 3.74196 31.023 5.06783C31.3765 6.39383 31.1923 7.77808 30.5047 8.96558L24.7063 18.9783C23.908 20.357 24.3801 22.1282 25.7585 22.9265C26.1969 23.1811 26.6948 23.3152 27.2017 23.315C28.1997 23.315 29.1719 22.7981 29.7068 21.8744L31.1533 19.3763C31.3271 19.0765 31.2248 18.6927 30.9248 18.5189V18.5188ZM17.0227 9.25058C17.1723 8.99327 17.4795 8.88308 17.7522 8.97152C17.7563 8.97296 17.7602 8.97421 17.7642 8.97564C17.7793 8.98102 17.794 8.98664 17.8085 8.99302C17.8257 9.00052 17.8423 9.00889 17.8587 9.01789C17.8628 9.02039 17.8672 9.02208 17.8713 9.02452L17.8728 9.02521C18.169 9.19708 18.2703 9.57771 18.0989 9.87433L16.6907 12.3058C16.65 12.3765 16.5956 12.4384 16.5308 12.488C16.4659 12.5375 16.3919 12.5737 16.313 12.5945C16.2341 12.6157 16.1518 12.6211 16.0709 12.6103C15.9899 12.5996 15.9119 12.5729 15.8413 12.5318C15.7704 12.4911 15.7084 12.4367 15.6587 12.3717C15.609 12.3068 15.5728 12.2327 15.552 12.1536C15.5307 12.0748 15.5252 11.9925 15.536 11.9115C15.5468 11.8305 15.5735 11.7525 15.6147 11.682L17.0227 9.25058ZM8.27979 8.88583C9.40016 6.95102 11.207 5.56846 13.3674 4.99252C15.3245 4.47077 17.3596 4.66783 19.1636 5.54252L17.9053 7.71564C17.6301 7.66366 17.3468 7.67443 17.0764 7.74714C16.6411 7.86314 16.2703 8.12633 16.0181 8.49371C16.0176 8.49452 16.017 8.49527 16.0163 8.49596C15.9895 8.53521 15.9636 8.57552 15.9395 8.61727L14.5257 11.0585C14.1179 11.7625 14.2224 12.6243 14.7229 13.211L13.9307 14.5791L7.21066 10.732L8.27979 8.88583ZM17.3875 26.5653C15.0745 30.5594 9.9431 31.9271 5.94897 29.6141C1.95485 27.301 0.587161 22.17 2.90016 18.1758L6.58035 11.8206L21.0676 20.21L17.3875 26.5653ZM23.6116 10.9246C24.1875 13.085 23.8875 15.3404 22.7671 17.2753L21.7187 19.0855L15.0183 15.2051L15.8083 13.8406C15.9217 13.8623 16.0367 13.8733 16.1521 13.8734C16.3137 13.8734 16.4765 13.8524 16.637 13.8096C17.1199 13.6808 17.5237 13.3719 17.7739 12.9395L19.1877 10.4984C19.5952 9.79452 19.491 8.93296 18.9905 8.34577L20.2495 6.17121C21.9062 7.30058 23.0898 8.96758 23.6116 10.9246Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_1081_57'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.51416)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Gym
